

const init = function() {
  
  try{
    
    /** logic for dropdown menu on main product **/
    let infiniteOptions = document.getElementById('infiniteoptions-container');
    let target_dropdown = document.getElementById('target-dropdown');
    
    let self_setup_input = document.createElement('input');
    
    //asterisk for info setup infinite-options 
    let asterisk = document.createElement('div'); 
    asterisk.className = 'asterisk-extra';
    let p_asterisk = document.createElement('p');
    let a_asterisk = document.createElement('a');
    a_asterisk.href = "mailto:info@daymakertouring.com";
    a_asterisk.title = 'info@daymakertouring.com';
    a_asterisk.innerHTML = "info@daymakertouring.com";
    
    let textHolder = document.createTextNode('* If unsure, type NA in the first box below and email us at ');
    let textHoldAfter = document.createTextNode(' after ordering');
    
    p_asterisk.appendChild(textHolder);
    p_asterisk.appendChild(a_asterisk);
    p_asterisk.appendChild(textHoldAfter);
    asterisk.appendChild(p_asterisk); 
    
    
    function elementReady(selector, rootEle) {
      return new Promise((resolve, reject) => {
        let rootElement = rootEle || document;
        let el = rootElement.querySelector(selector);
        if (el) {resolve(el);}
        new MutationObserver((mutationRecords, observer) => {
          // Query for elements matching the specified selector
          Array.from(rootElement.querySelectorAll(selector)).forEach((element) => {
            resolve(element);
            //Once we have resolved we don't need the observer anymore.
            observer.disconnect();
          });
        })
          .observe(document.documentElement, {
            childList: true,
            subtree: true
          });
      });
    }

    
    let inputToggleResolved = null
    elementReady('input', infiniteOptions).then((theInput)=>{
      inputToggleResolved = theInput; 
      inputToggleResolved.required = true;

      const targetPresetup = document.querySelector('.presetup-helper') // THIS IS CLASSNAME SET ON RADIO ELEMENT OF INFINITE OPTIONS

      infiniteOptions.insertBefore(target_dropdown, targetPresetup.nextSibling);

      const labelElements = targetPresetup.querySelectorAll('label');
      const lastLabel = labelElements[labelElements.length - 1];
      lastLabel.style.width = 'fit-content'
      if(lastLabel){
        const anchor = document.createElement('a')
        anchor.href = "https://youtu.be/Qowl-LiOtM4"
        anchor.textContent = "Assembly Tutorial"
        anchor.target = '_blank'; 
        anchor.style.verticalAlign = 'text-bottom';
        anchor.style.color = '#526474';
        anchor.style.marginLeft = '0.7em';
        anchor.style.textDecoration = 'underline';
        const labelparent = lastLabel.parentNode;
        if (lastLabel.nextSibling) {
          labelparent.insertBefore(anchor, lastLabel.nextSibling);
        } else {
          labelparent.appendChild(anchor); // If no sibling exists, append the anchor
        }
      }
      
      target_dropdown.style.display = "block";
    });
    
    
    //create input element for presetup info
    let input = document.createElement('input');
    input.type = "checkbox";
    input.checked = true;
    input.className = "dynamic-checkbox";
    input.addEventListener('click', function(){
      if(input.checked){
        // infiniteOptions.style.maxHeight = "200px";
        self_setup_input.checked = false;
        inputToggleResolved.required = true;

      }
      else{
        infiniteOptions.style.maxHeight = "0px";
        self_setup_input.checked = true;
        inputToggleResolved.required = false;

      }
    });
    
    //create input element for personal setup
    
    // self_setup_input.type = "checkbox";
    // self_setup_input.classList.add("self-setup-checkbox", "dynamic-checkbox");
    // self_setup_input.addEventListener('click', function(){
    //   if (self_setup_input.checked){
    //     input.checked = false; 
    //     infiniteOptions.style.maxHeight = "0px";
    //     inputToggleResolved.required = false;
    //   }
    //   else{
    //     input.checked = true; 
    //     infiniteOptions.style.maxHeight = "200px";
    //     inputToggleResolved.required = true;
    //   }
    // });
    
    
    
    // let containerDiv = document.createElement('div');
    // containerDiv.className = "toggle-info-div";
    
    let pInfoSpanContainer = document.createElement('span');
    pInfoSpanContainer.className = "pInfoSpanContainer";
    
    let p_copy = document.createElement('p');
    p_copy.innerHTML = "Presetup For Me";
    
    let self_copy = document.createElement('p');
    self_copy.innerHTML = "I Will Setup Myself"; 
    self_copy.className = "self-setup-copy";
    
    let info_icon = document.createElement('span');
    info_icon.className = "extra-info-icon";
    
    let info_i = document.createElement('b');
    info_i.className = "info-i info-i-text-bsl";
    info_i.innerHTML = 'i';
    
    info_icon.appendChild(info_i);
    
    let info_svg = document.getElementsByClassName('info-svg')[0];
 
    
    // pInfoSpanContainer.appendChild(p_copy);
    // pInfoSpanContainer.appendChild(info_icon);
    
    // containerDiv.appendChild(input);

    
    // containerDiv.appendChild(p_copy);
    // containerDiv.appendChild(info_icon);
    
    // containerDiv.appendChild(pInfoSpanContainer);
    
    if(target_dropdown){
    	// target_dropdown.appendChild(containerDiv);
        target_dropdown.appendChild(info_icon)
      	target_dropdown.appendChild(asterisk);
    }
    
    // containerDiv.appendChild(self_setup_input);
    // containerDiv.appendChild(self_copy);
    
     
    //First Modal logic
    let header = document.getElementsByClassName('header')[0];
    // let stickyHeader = document.querySelector('.sticky-header');
    let stickyHeader = document.querySelector('[data-main-header="header"]')
    
    function openModal(modal) {
    // Note: fixed elements will also need the margin 
    // adjustment (like a fixed header, if you have one).
    modal.classList.add('modal-custom-show');
    let scrollBarWidth = window.innerWidth - document.body.offsetWidth;
    document.body.style.margin = '0px ' + scrollBarWidth + 'px 0px 0px';
    stickyHeader.style.paddingRight = scrollBarWidth + `px`; 
    document.body.style.overflow = 'hidden';
    modal.style.overflowY = "visible";
  };
  
  function closeModal(modal) {
    document.body.style.margin = '';
    document.body.style.overflow = '';
    stickyHeader.style.paddingRight = '';
    modal.classList.remove('modal-custom-show');
    modal.style.overflow = "hidden";  
    header.style.zIndex = 99;

  };
    
  let modal = document.getElementById('modal-custom');
  let closeModalBtn = document.getElementById('close-modal-custom');

  closeModalBtn.addEventListener('click', function(event){
    event.preventDefault();
    closeModal(modal);
  });
    
    
  modal.addEventListener('click', function () {
    closeModal(modal);
  });
  for (var i = 0; i <  modal.childNodes.length; i++) {
      modal.childNodes[i].addEventListener('click', function (event) {
          event.stopPropagation();
      });
  }
    
    
    info_icon.addEventListener('click', function(event) {
      event.preventDefault();
      openModal(modal);
       header.style.zIndex = 1;
    });
    
    
    //Second Modal logic
    let productOptionsTarget = document.querySelector('.asterisk-extra');
    let infoBSL = document.createElement('span');
    infoBSL.className = 'infoBSL';
    
    let info_i2 = document.createElement('b');
    info_i2.innerHTML = "i";
    info_i2.className = 'info-i info-i-text';
    
    infoBSL.appendChild(info_i2);

    productOptionsTarget.insertBefore(info_icon, productOptionsTarget.childNodes[0])
    productOptionsTarget.insertBefore(infoBSL, productOptionsTarget.childNodes[1]);
    let modalBSL = document.getElementById('modal-bsl');
    
    let closeModalBtnBSL = document.getElementById('close-modal-bsl');

  closeModalBtnBSL.addEventListener('click', function(event){
    event.preventDefault();
    closeModal(modalBSL);
  });
    
  infoBSL.addEventListener('click', function(event) {
      event.preventDefault();
      openModal(modalBSL);
       header.style.zIndex = 1;
    });
    
    modalBSL.addEventListener('click', function (event) {
      event.preventDefault();
    closeModal(modalBSL);
  });
  for (var i = 0; i <  modalBSL.childNodes.length; i++) {
      modalBSL.childNodes[i].addEventListener('click', function (event) {
          event.stopPropagation();
      });
  }
    
   
    
    /** reviews logic **/
 //    let sprReviews = document.getElementById('shopify-product-reviews');
	// sprReviews.style.visibility = "hidden"; 
	// var itm = document.querySelector(".spr-summary");
 //    var cln = itm.cloneNode(true);
 //    //var cln2 = itm.cloneNode(true);
    

    
 //    document.querySelector(".star-review-wrapper").appendChild(cln);
 //    document.querySelector(".star-review-wrapper-mobile").appendChild(itm.cloneNode(true));
  
 //    document.querySelector(".star-review-wrapper").alt = "See what people are saying";
 //    document.querySelector(".star-review-wrapper-mobile").alt = "See what people are saying";
    
    
  }
  catch(err){
  
  }
  
  
  
 
};

 

 /* Change layout of reviews so writing a review comes last */
// const swapReviews = function () {
  
  
//   try{
//   	let sprReviews = document.querySelector(".spr-reviews");
//   	let firstDOM = document.getElementsByClassName("spr-form");  
//     let cartldr = document.getElementById('cartloadingContainer');
 
    
//     if(sprReviews){
//       sprReviews.style.display = "block";
//       sprReviews.appendChild(firstDOM[0]);
//       let sprReviewsVis = document.getElementById('shopify-product-reviews');
//       sprReviewsVis.style.visibility = "visible";
//       cartldr.style.display = "none";
//     }
//     else{
//       cartldr.style.display = "none";
//     }
   
//   } 
  

    
//   catch(err){
//      console.log(err);
//   }
// };
  
 
 
document.addEventListener('DOMContentLoaded', init);
// setTimeout(swapReviews, 6000);







